export const SITE_URL = 'https://jazinfotech.com';

export const COMPANY = {
  name: 'Jaz Infotech',
  legalName: 'Jaz Infotech',
  phone: '+91-6383628551',
  email: 'hr@jazinfotech.com',
  logo: `${SITE_URL}/images/logo/logo.png`,
  address: {
    streetAddress: "B-231, NGO B Colony, 15th Street, Palayamkottai",
    addressLocality: 'Tirunelveli',
    addressRegion: 'Tamil Nadu',
    postalCode: '627007',
    addressCountry: 'IN',
  },
  geo: {
    latitude: 8.7139,
    longitude: 77.7567,
  },
  sameAs: [
    'https://www.facebook.com/jazinfotech',
    'https://www.linkedin.com/company/jaz-infotech',
  ],
};

export function postalAddress() {
  return { '@type': 'PostalAddress', ...COMPANY.address };
}

export function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: COMPANY.name,
    url: SITE_URL,
    logo: COMPANY.logo,
    email: COMPANY.email,
    telephone: COMPANY.phone,
    address: postalAddress(),
    sameAs: COMPANY.sameAs,
  };
}

export function localBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#localbusiness`,
    name: COMPANY.name,
    image: COMPANY.logo,
    url: SITE_URL,
    telephone: COMPANY.phone,
    email: COMPANY.email,
    priceRange: '$$',
    address: postalAddress(),
    geo: {
      '@type': 'GeoCoordinates',
      latitude: COMPANY.geo.latitude,
      longitude: COMPANY.geo.longitude,
    },
    openingHoursSpecification: [{
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '10:00',
      closes: '18:00',
    }],
    areaServed: {
      '@type': 'City',
      name: 'Tirunelveli',
    },
  };
}

export function webSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: COMPANY.name,
    url: SITE_URL,
    publisher: { '@id': `${SITE_URL}/#organization` },
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/blog?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
}

export function professionalServiceSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': `${SITE_URL}/#service`,
    name: COMPANY.name,
    description: 'Custom software development and mobile app development company in Tirunelveli.',
    url: SITE_URL,
    logo: COMPANY.logo,
    telephone: COMPANY.phone,
    email: COMPANY.email,
    address: postalAddress(),
    areaServed: 'Tirunelveli',
    serviceType: [
      'Custom Software Development',
      'Mobile App Development',
      'Web Application Development',
    ],
  };
}

export function homePageSchemas() {
  return [
    organizationSchema(),
    localBusinessSchema(),
    webSiteSchema(),
    professionalServiceSchema(),
  ];
}

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url.startsWith('http') ? item.url : `${SITE_URL}${item.url}`,
    })),
  };
}

export function faqSchema(faqs) {
  const valid = (faqs || []).filter((f) => f.q && f.a);
  if (!valid.length) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: valid.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}

export function articleSchema({ title, description, slug, image, publishedAt, updatedAt }) {
  const url = `${SITE_URL}/${slug}`;
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    url,
    mainEntityOfPage: url,
    image: image || COMPANY.logo,
    datePublished: publishedAt,
    dateModified: updatedAt || publishedAt,
    author: { '@type': 'Organization', name: COMPANY.name, url: SITE_URL },
    publisher: {
      '@type': 'Organization',
      name: COMPANY.name,
      logo: { '@type': 'ImageObject', url: COMPANY.logo },
    },
  };
}

export function servicePageSchema({ title, description, slug }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: title,
    description,
    url: `${SITE_URL}/services/${slug}`,
    provider: { '@id': `${SITE_URL}/#organization` },
    areaServed: 'Tirunelveli',
  };
}
